import React from 'react';
import { Box } from 'native-base';
import Overview from './Overview';
import HandlePost from '../common/HandlePost';
const ForumHeader = ({
  navigation,
  startNewTopicButtonRef,
  setPage,
  setHasMoreTopics,
  updateTopicPost,
  updateTopicReplies,
  showUserProfile,
  trackForum,
  colors
}) => {
  return /*#__PURE__*/React.createElement(Box, {
    w: '100%',
    borderColor: colors.forumHomeScreen.header.border,
    borderWidth: {
      base: 0,
      lg: 1
    },
    borderRadius: 8,
    overflow: {
      base: 'visible',
      lg: 'hidden'
    }
  }, /*#__PURE__*/React.createElement(Overview, {
    navigation: navigation,
    borderRadius: 8,
    startNewTopicButtonRef: startNewTopicButtonRef,
    setPage: setPage,
    setHasMoreTopics: setHasMoreTopics
  }), /*#__PURE__*/React.createElement(HandlePost, {
    startNewTopicButtonRef: startNewTopicButtonRef,
    updateTopicPost: updateTopicPost,
    navigation: navigation,
    forceTypeTopic: true,
    updateTopicReplies: updateTopicReplies,
    showUserProfile: showUserProfile,
    trackForum: trackForum
  }));
};
export default ForumHeader;
//# sourceMappingURL=ForumHeader.js.map